import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';

import moment from 'moment';
import DateNavigation from './dateNavigation';
import CalendarEventComponent, { EVENT_TYPE, generateTitle } from './calendarEventComponent';
import { CalendarLegend } from '../../helpers/colors';
import { API_ENDPOINT } from '../../constants';
import { Tooltip } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { convertSvDateToEn } from './helper';

const LightTooltipHoliday = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#e61f00",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

function checkEventOverlap(event, eventList) {
    let overlappingEvents = [];

    const { startTime: eventStart, endTime: eventEnd } = event;

    for (let currentEvent of eventList) {
        const { startTime: currentStart, endTime: currentEnd } = currentEvent;

        if (
            (eventStart < currentEnd && eventEnd > currentStart) ||
            (eventStart <= currentStart && eventEnd >= currentEnd) // && (eventEnd >= currentEnd || (eventEnd < currentEnd && eventEnd > currentStart))
        ) {
            overlappingEvents.push(currentEvent);
        }
    }

    return overlappingEvents.length > 0 ? overlappingEvents : null;
}
function minutesToHHMM(minutes) {
    if (!minutes || !parseInt(minutes) || parseInt(minutes) <= 0) return '00:00';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}


function formatName(name, maxWordLength = 10, addDot = true) {
    let splittedName = name.split(' ');
    let formattedName = '';
    for (let i = 0; i < splittedName.length; i++) {
        if (splittedName[i].length > maxWordLength) {
            formattedName += splittedName[i].slice(0, maxWordLength) + `${addDot ? '. ' : ' '}`;
        } else {
            formattedName += splittedName[i] + ' ';
        }
    }
    return formattedName;
}
function convertMinutesToTime(totalMinutes) {
    if (!totalMinutes || !parseInt(totalMinutes) || parseInt(totalMinutes) <= 0) return '00:00';
    totalMinutes = parseInt(totalMinutes);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};


class CustomCalendar extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.calendarInitialBlockRef = React.createRef();

        this.state = {
            view: 'day',
            date: this.props?.getStringDateTs ? this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY') : moment.unix(Math.floor(new Date().getTime() / 1000)).format('MM/DD/YYYY'),
            items: [],
            cols: [],
            zoom: 0,
            step: 5,
            steps: [1, 5, 10, 15, 30],
            initialScroll: false,
            holidayEvents: []
        }
    }
    googleHolidayEvents = () => {
        fetch(API_ENDPOINT + '/google/holidays/events/' + this.props.selectedGroup, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang)
                })
            } else {

                if (this.state.holidayEvents && this.state.holidayEvents.length && result.items && result.items.length) {
                    let holidayEvents = [...this.state.holidayEvents, ...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }
                    holidayEvents = holidayEvents.map(item => {
                        return {
                            ...item,
                            _date: convertSvDateToEn(item.date)
                        }
                    });

                    this.setState({ holidayEvents })
                } else if (result.items && result.items.length) {
                    let holidayEvents = [...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }

                    holidayEvents = holidayEvents.map(item => {
                        return {
                            ...item,
                            _date: convertSvDateToEn(item.date)
                        }
                    });

                    this.setState({ holidayEvents })
                }

            }
        })
    }

    setInitialData = () => {
        let cols = this.props.items?.length ? this.props.items : [];


        let date = this.props?.getStringDateTs ?
            this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
            : moment.unix(Math.floor(new Date().getTime() / 1000)).format('MM/DD/YYYY')

        this.setState({
            date,
            cols
        }, () => {
            if (this.props.onChangeDate) {
                this.props.onChangeDate(this.state.date, this.state.view);
            }
        })
    }

    resizeWindow = () => {
        if (window.innerWidth !== this.screenWidth) {
            this.screenWidth = window.innerWidth;
            let screenWidth = this.state.screenWidth ?? 0;
            let difference = Math.abs(this.screenWidth - screenWidth);
            if (difference > 100) {
                this.setState({
                    screenWidth: this.screenWidth
                })
            }
        }
    }

    componentDidMount() {
        this.setInitialData();

        window?.addEventListener('resize', this.resizeWindow);

        if (this.props.registerScrollToInitialBlock) {
            this.props.registerScrollToInitialBlock(this.scrollToInitialBlock);
        }
        if (this.props.registerCancelLayoutElementChange) {
            this.props.registerCancelLayoutElementChange(this.cancelLayoutElementChange);
        }

        this.googleHolidayEvents();

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.date !== prevState.date || this.state.view !== prevState.view && this.props.onChangeDate) {
            this.props.onChangeDate(this.state.date, this.state.view);
        }
        if (this.props.items !== prevProps.items || JSON.stringify(this.props.items) !== JSON.stringify(prevProps.items)) {
            let cols = this.props.items?.length ? this.props.items : [];
            this.setState({
                cols,
                updatedLayoutElement: null
            })
        }
        if (this.props?.items?.length && !this.state.initialScroll) {
            this.setState({ initialScroll: true }, () => {
                this.scrollToInitialBlock();
            })
        }

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeWindow);
        if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

    }

    setOverlapDataToEvent = (item, overlap) => {
        let items = [{ ...item }, ...overlap];

        let overlapData = {
            // position: newArr.findIndex(el => el._id == item._id),
            overlap: overlap?.map(el => el._id),
            total: items.length
        }

        return overlapData;
    }
    checkPosition = (items) => {
        for (let i = 0; i < items.length; i++) {
            if (!items[i].overlapData || (items[i].overlapData?.sorted)) {
                continue;
            }
            let overlap = items[i].overlapData.overlap;
            let position = 0;
            for (let j = 0; j < overlap.length; j++) {
                let element = items.find(el => el._id == overlap[j]);
                if (element?.overlapData?.sorted) {
                    position++;
                }
            }
            items[i].overlapData.position = position;
            items[i].overlapData.sorted = true;

        }


        return items;
    }
    checkOverlap = (items) => {
        for (let i = 0; i < items.length; i++) {
            delete items[i].overlapData;
            let item = items[i];
            let overlap = checkEventOverlap(item, items.filter(el => el._id != item._id && el.doctor === item.doctor));
            if (overlap?.length) {
                items[i].overlapData = this.setOverlapDataToEvent({ ...item }, [...overlap])
            }
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].overlapData?.overlap?.length) {
                let overlap = items[i].overlapData.overlap;
                for (let j = 0; j < items[i].overlapData.overlap.length; j++) {
                    let element = items.find(el => el._id == items[i].overlapData.overlap[j]);
                    if (element?.overlapData?.overlap?.length) {
                        for (let e = 0; e < element.overlapData.overlap.length; e++) {
                            if (!items[i].overlapData.overlap.includes(element.overlapData.overlap[e])) {
                                overlap.push(element.overlapData.overlap[e])
                            }
                        }
                    }
                }
                items[i].overlapData.overlap = overlap;
                items[i].overlapData.total = items[i].overlapData.overlap.length;
            }
        }
        return this.checkPosition(items?.sort((a, b) => a.startTime - b.startTime));
    }
    generateLayout = (cols) => {
        const COLS = cols ?? this.state.cols;
        let layout = [];
        let items = [];

        const tsNow = Math.floor(new Date().getTime() / 1000);
        for (let i = 0; i < COLS.length; i++) {
            for (let j = 0; j < COLS[i].events.length; j++) {
                const colDate = COLS[i].date;
                const event = COLS[i].events[j];
                if (!event.deleted && !event.forDelete) {
                    let startString = this.props.getStringDateTs(event.startTime, 'MM/DD/YYYY HH:mm');
                    let startTs = Math.floor(new Date(startString).getTime() / 1000);

                    if (startString?.indexOf(colDate) === -1) {
                        continue;
                    }


                    let startDate = new Date(startString);
                    startDate.setHours(0);
                    startDate.setMinutes(0);
                    startDate.setSeconds(0);
                    startDate.setMilliseconds(0);
                    let startTimestamp = Math.floor(startDate.getTime() / 1000);

                    const inClipboard = this.state.clipboard?.find(el => el._id === event._id);

                    event.stringTime = startString;
                    event.startDate = startDate;
                    event.startTimestamp = startTimestamp;
                    event.diff = Math.floor(startDate?.getTime() / 1000) - startTimestamp;
                    const eventHasOverlap = event?.overlapData?.overlap?.length;
                    const isStatic = event.startTime < tsNow
                        || this.state.dragElementType?._id  // dragging from clipboard
                        || event.eventId
                        || event.eventFromAnotherClinic
                        || event.takeCare
                        || event.semble
                        || inClipboard
                        || event.reserved
                        || event.hidden
                        || event?._id?.indexOf('additional') > -1
                        ? true
                        : false;
                    event.isStatic = isStatic && !eventHasOverlap ? true : false;

                    const y = Math.ceil((startTs - startTimestamp) / (this.state.step * 60));
                    const h = Math.ceil((((event.endTime - event.startTime) / (this.state.step * 60))));

                    layout.push({
                        i: event._id,
                        x: i,
                        w: 1,
                        maxW: 1,
                        y: y,
                        h: h,
                        static: isStatic && !eventHasOverlap,
                        isResizable: !isStatic && event?.type !== 'template' ? true : false,
                        isDraggable: !isStatic && !this.state.handlingEvent
                    })
                    items.push({
                        ...event,
                        column: i
                    });

                }
            }
        }
        items.sort((a, b) => b.startTime - a.startTime)

        items = this.checkOverlap(items);

        let daySplitted = [];
        const dateSplit = this.state.date?.split('/');
        const day = parseInt(dateSplit?.[1]);
        const month = parseInt(dateSplit?.[0] - 1);
        const year = parseInt(dateSplit?.[2]);

        const minHours = this.props?.min?.hours ?? 0;
        const minMinutes = this.props?.min?.minutes ?? 0;
        const maxHours = this.props?.max?.hours ?? 23;
        const maxMinutes = this.props?.max?.minutes ?? 59;

        let newDate = new Date(year, month, day, minHours, minMinutes, 0, 0);
        let endDate = new Date(year, month, day, maxHours, maxMinutes, 59, 999);

        for (let i = 0; i < (endDate.getTime() - newDate.getTime()) / 1000 / 60 / 60; i++) {
            let newDate = new Date(year, month, day, minHours, minMinutes, 0, 0);
            newDate.setMinutes(i * 60);
            let time = moment.unix(Math.floor(newDate.getTime() / 1000)).format('HH:mm');
            daySplitted.push({
                time,
                date: newDate,
                timestamp: Math.floor(newDate.getTime() / 1000)
            });
        }

        return {
            LAYOUT: layout,
            ITEMS: items,
            DAY_SPLITTED: daySplitted
        };
    }
    getWeekDates = (dateString) => {
        if (!dateString) return null;
        const [month, day, year] = dateString.split('/').map(Number);
        const date = new Date(year, month - 1, day);

        let dayOfWeek = date.getDay();

        const monday = new Date(date);
        const diff = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
        monday.setDate(date.getDate() + diff);

        const weekDates = Array.from({ length: 7 }, (_, i) => {
            const currentDate = new Date(monday);
            currentDate.setDate(monday.getDate() + i);

            return (
                String(currentDate.getMonth() + 1).padStart(2, '0') + '/' +
                String(currentDate.getDate()).padStart(2, '0') + '/' +
                currentDate.getFullYear()
            );
        });

        return weekDates;
    }
    getWorkWeekDates = (dateString) => {
        if (!dateString) return null;
        const [month, day, year] = dateString.split('/').map(Number);
        const date = new Date(year, month - 1, day);

        let dayOfWeek = date.getDay();

        const monday = new Date(date);
        const diff = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
        monday.setDate(date.getDate() + diff);

        const weekDates = Array.from({ length: 5 }, (_, i) => {
            const currentDate = new Date(monday);
            currentDate.setDate(monday.getDate() + i);

            return (
                String(currentDate.getMonth() + 1).padStart(2, '0') + '/' +
                String(currentDate.getDate()).padStart(2, '0') + '/' +
                currentDate.getFullYear()
            );
        });

        return weekDates;
    }
    getDateFormatted = (dateString) => {
        if (!dateString) return null;
        const [month, day, year] = dateString.split('/').map(Number);
        const date = new Date(year, month - 1, day);
        const dayOfWeek = date.getDay();
        const lang = this.props.lang;
        const dayOfWeekString = [
            'Sun'.translate(lang),
            'Mon'.translate(lang),
            'Tue'.translate(lang),
            'Wed'.translate(lang),
            'Thu'.translate(lang),
            'Fri'.translate(lang),
            'Sat'.translate(lang)
        ];
        return `${String(date.getDate()).padStart(2, '0')} ${dayOfWeekString[dayOfWeek]}`;
    }
    getWeekNumber = (dateString) => {
        // if (!dateString) return null;
        // let date = new Date(dateString);
        // date.setHours(12, 0, 0, 0);
        // date.setDate(date.getDate() - 1);
        // const m = moment(date);

        // return m.week();
        if (!dateString) return null;

        const m = moment(dateString, 'MM/DD/YYYY', true);
        if (!m.isValid()) return null;

        return m.isoWeek();
    }
    generateCols = () => {
        let cols = this.state.cols;
        let response = {
            cols: []
        };
        let headerDates = {
            weekNumber: this.getWeekNumber(this.state.date),
            days: [],
            spanColumns: cols?.length
        };

        if (this.state.view === 'day') {
            response.cols = cols.map((item, idx) => {
                return {
                    ...item,
                    date: this.state.date,
                    isToday: this.state.date === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                }
            });
            headerDates.days.push({
                dateString: this.state.date,
                dateFormatted: this.getDateFormatted(this.state.date),
                isToday: this.state.date === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
            });
        } else if (this.state.view === 'week') {
            let weekDays = this.getWeekDates(this.state.date);
            if (!weekDays || weekDays?.length !== 7) return [];
            for (let i = 0; i < weekDays.length; i++) {
                for (let j = 0; j < cols.length; j++) {
                    let obj = {
                        ...cols[j],
                        date: weekDays[i],
                        isToday: weekDays[i] === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                    };
                    if (lastDate !== weekDays[i] && j === cols.length - 1) {
                        obj.borderRight = true;
                    }
                    response.cols.push(obj)
                }
                let lastDate = weekDays[i];
                headerDates.days.push({
                    dateString: weekDays[i],
                    dateFormatted: this.getDateFormatted(weekDays[i]),
                    isToday: weekDays[i] === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                });
            }
        } else if (this.state.view === 'work-week') {
            let weekDays = this.getWorkWeekDates(this.state.date);
            if (!weekDays || weekDays?.length !== 5) return [];
            for (let i = 0; i < weekDays.length; i++) {
                for (let j = 0; j < cols.length; j++) {
                    let obj = {
                        ...cols[j],
                        date: weekDays[i],
                        isToday: weekDays[i] === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                    };
                    if (lastDate !== weekDays[i] && j === cols.length - 1) {
                        obj.borderRight = true;
                    }
                    response.cols.push(obj)
                }
                let lastDate = weekDays[i];
                headerDates.days.push({
                    dateString: weekDays[i],
                    dateFormatted: this.getDateFormatted(weekDays[i]),
                    isToday: weekDays[i] === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                });
            }
        }
        headerDates.navigationDate = this.getNavigationDate(headerDates.days);
        response.headerDates = headerDates;
        return response;
    }
    getNavigationDate = (days) => {
        if (!days?.length) return null;
        const view = this.state.view;
        const lang = this.props.lang;

        if (view === 'day' && days?.[0]?.dateString) {
            let dateString = days?.[0]?.dateString;
            const [month, day, year] = dateString.split('/').map(Number);
            const date = new Date(year, month - 1, day);
            const dayOfWeek = date.getDay();
            const dayOfWeekString = [
                'Sunday'.translate(lang),
                'Monday'.translate(lang),
                'Tuesday'.translate(lang),
                'Wednesday'.translate(lang),
                'Thursday'.translate(lang),
                'Friday'.translate(lang),
                'Saturday'.translate(lang)
            ];

            const monthString = [
                'Jan'.translate(lang),
                'Feb'.translate(lang),
                'Mar'.translate(lang),
                'Apr'.translate(lang),
                'May'.translate(lang),
                'Jun'.translate(lang),
                'Jul'.translate(lang),
                'Aug'.translate(lang),
                'Sep'.translate(lang),
                'Oct'.translate(lang),
                'Nov'.translate(lang),
                'Dec'.translate(lang)
            ];
            return `${dayOfWeekString[dayOfWeek]} ${monthString?.[month - 1]} ${String(date.getDate()).padStart(2, '0')}`
        } else if ((view === 'week' || view === 'work-week') && days?.length) {
            let startDate = days?.[0]?.dateString;
            let endDate = days?.[days.length - 1]?.dateString;
            const [startMonth, startDay, startYear] = startDate.split('/').map(Number);
            const [endMonth, endDay, endYear] = endDate.split('/').map(Number);
            const _startDay = new Date(startYear, startMonth - 1, startDay);
            const _endDay = new Date(endYear, endMonth - 1, endDay);

            const shortMonthString = [
                'Jan'.translate(lang),
                'Feb'.translate(lang),
                'Mar'.translate(lang),
                'Apr'.translate(lang),
                'May'.translate(lang),
                'Jun'.translate(lang),
                'Jul'.translate(lang),
                'Aug'.translate(lang),
                'Sep'.translate(lang),
                'Oct'.translate(lang),
                'Nov'.translate(lang),
                'Dec'.translate(lang)
            ];
            const monthString = [
                'January'.translate(lang),
                'February'.translate(lang),
                'March'.translate(lang),
                'April'.translate(lang),
                'May'.translate(lang),
                'June'.translate(lang),
                'July'.translate(lang),
                'August'.translate(lang),
                'September'.translate(lang),
                'October'.translate(lang),
                'November'.translate(lang),
                'December'.translate(lang)
            ];
            const startMonthString = startMonth === endMonth ? monthString?.[startMonth - 1] : shortMonthString?.[startMonth - 1];
            const endMonthString = startMonth === endMonth ? monthString?.[endMonth - 1] : shortMonthString?.[endMonth - 1];

            if (startMonth === endMonth) {
                return `${startMonthString} ${String(_startDay.getDate()).padStart(2, '0')} – ${String(_endDay.getDate()).padStart(2, '0')}`;
            } else {
                return `${startMonthString} ${String(_startDay.getDate()).padStart(2, '0')} – ${endMonthString} ${String(_endDay.getDate()).padStart(2, '0')}`;
            }


        }
    }
    getMaxVisibleCols = () => {
        const cols = this.state.cols;
        const zoom = this.state.zoom;
        const view = this.state.view;
        const numberOfDaysDict = {
            day: 1,
            week: 7,
            'work-week': 5
        };
        if (view === 'day') return cols.length;
        if (view === 'week') {
            if (zoom <= 0) {
                return cols.length * numberOfDaysDict[view];
            } else if (zoom > 0 && zoom <= 7) {
                return cols.length * (numberOfDaysDict[view] - zoom);
            } else if (zoom > 7) {
                return cols.length * 7;
            }
        }
        if (view === 'work-week') {
            if (zoom <= 0) {
                return cols.length * numberOfDaysDict[view];
            } else if (zoom > 0 && zoom <= 5) {
                return cols.length * (numberOfDaysDict[view] - zoom);
            } else if (zoom > 5) {
                return cols.length * 5;
            }
        }


    }
    zoomOut = () => {
        let zoom = this.state.zoom;
        if (zoom === 0) return;
        this.setState({
            zoom: zoom - 1
        })
    }
    zoomIn = () => {
        let zoom = this.state.zoom;
        const view = this.state.view;
        const numberOfDaysDict = {
            day: 1,
            week: 7,
            'work-week': 5
        };
        if (zoom === numberOfDaysDict?.[view]) return;
        this.setState({
            zoom: zoom + 1
        })
    }
    stepZoomOut = () => {
        const step = this.state.step;
        const steps = this.state.steps;
        const minStep = steps?.[0] ?? 1;
        if (step === minStep) return;
        const index = steps?.findIndex(el => el === step);
        const nextIndex = index - 1;
        if (nextIndex < 0 || !steps[index]) return;

        this.setState({ step: steps[nextIndex] })
    }
    stepZoomIn = () => {
        const step = this.state.step;
        const steps = this.state.steps;
        const maxStep = steps?.[steps.length - 1] ?? 30;
        if (step === maxStep) return;
        const index = steps?.findIndex(el => el === step);
        const nextIndex = index + 1;
        if (nextIndex >= steps.length || !steps[index]) return;

        this.setState({ step: steps[nextIndex] })
    }
    changeView = (view) => {
        let possibleViews = ['day', 'week', 'work-week'];
        if (!possibleViews.includes(view)) return;
        if (view === this.state.view) return;
        this.setState({
            view,
            zoom: 0
        })
    }
    onChangeEvent = (layout, oldItem, newItem, callback) => {
        if (!this.props.onChangeEvent) return;
        const COLS = this.generateCols()?.cols ?? [];
        const step = this.state.step ?? 5;

        let oldStartMinutes = oldItem?.y * step;
        let oldStartTime = convertMinutesToTime(oldStartMinutes);
        let oldEndMinutes = (oldItem?.y + oldItem?.h) * step;
        let oldEndTime = convertMinutesToTime(oldEndMinutes);

        let newStartMinutes = newItem?.y * step;
        let newStartTime = convertMinutesToTime(newStartMinutes);
        let newEndMinutes = (newItem?.y + newItem?.h) * step;
        let newEndTime = convertMinutesToTime(newEndMinutes);


        if (oldItem?.x === newItem?.x && !oldItem?.data) {
            // doctor not changed and date not changed, only time changed
            let oldData = {
                doctorId: COLS?.[oldItem?.x]?._id,
                doctorName: COLS?.[oldItem?.x]?.name
            };
            let newData = {
                doctorId: COLS?.[oldItem?.x]?._id,
                doctorName: COLS?.[oldItem?.x]?.name
            };
            let date = COLS?.[oldItem?.x]?.date;

            oldData.startTime = `${date} ${oldStartTime}`;
            oldData.endTime = `${date} ${oldEndTime}`;

            newData.startTime = `${date} ${newStartTime}`;
            newData.endTime = `${date} ${newEndTime}`;

            oldItem.data = oldData;
            newItem.data = newData;

        } else {
            // doctor changed
            let oldData = {
                doctorId: COLS?.[oldItem?.x]?._id,
                doctorName: COLS?.[oldItem?.x]?.name
            };
            let newData = {
                doctorId: COLS?.[newItem?.x]?._id,
                doctorName: COLS?.[newItem?.x]?.name
            };
            let oldDate = COLS?.[oldItem?.x]?.date;
            let newDate = COLS?.[newItem?.x]?.date;

            oldData.startTime = `${oldDate} ${oldStartTime}`;
            oldData.endTime = `${oldDate} ${oldEndTime}`;

            newData.startTime = `${newDate} ${newStartTime}`;
            newData.endTime = `${newDate} ${newEndTime}`;

            if (!oldItem?.data)
                oldItem.data = oldData;
            newItem.data = newData;

        }
        this.props.onChangeEvent(oldItem, newItem, callback);

    }
    setWidthOfElement = (className, width, counter = 0) => {
        if (typeof window == 'undefined') return;

        if (counter > 10) return;
        let element = document.getElementsByClassName(className);
        if (element?.length) {
            element[0].style.width = `${width}px`;
            if (counter === 0) {
                setTimeout(() => {
                    this.setWidthOfElement(className, width, counter + 1)
                }, 100);
            }
        } else {
            setTimeout(() => {
                this.setWidthOfElement(className, width, counter + 1)
            }, 100);
        }
    }
    setZIndexOfElement = (className, zIndex = null) => {
        if (typeof window == 'undefined') return;

        let element = document.getElementsByClassName(className);
        if (element?.length) {
            element[0].style.zIndex = zIndex ? zIndex : 'unset';
        }
    }
    cancelLayoutElementChange = () => {
        if (this.state.updatedLayoutElement) {
            this.setState({
                updatedLayoutElement: null
            })
        }
    }
    updateLayoutElement = (item, layoutItem) => {
        // console.log('updateLayoutElement', item, layoutItem)
        const eventId = layoutItem?.i;
        const y = layoutItem?.y;
        const h = layoutItem?.h;

        let start = y * this.state.step;
        let end = start + h * this.state.step;
        let updatedLayoutElement = {
            eventId: eventId,
            start: minutesToHHMM(start),
            end: minutesToHHMM(end)
        };
        let updatedLayoutElementState = this.state.updatedLayoutElement ?? {};

        if (updatedLayoutElement?.eventId !== updatedLayoutElementState?.eventId || updatedLayoutElement?.start !== updatedLayoutElementState?.start || updatedLayoutElement?.end !== updatedLayoutElementState?.end) {
            this.setState({
                updatedLayoutElement: updatedLayoutElement
            })

        }

    }
    scrollToInitialBlock = (count = 0) => {
        if (this.calendarInitialBlockRef) {
            this.calendarInitialBlockRef?.scrollIntoView({ behavior: 'instant', block: 'start' });
        } else {
            if (count < 10) {
                if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
                this.scrollTimeout = setTimeout(() => {
                    this.scrollToInitialBlock(count + 1)
                }, 100);
            }
        }
    }
    checkIfAnyHolidayEventExists = (days) => {
        if (!days?.length) return false;
        const holidayEvents = this.state.holidayEvents ?? [];

        let check = false;
        for (let i = 0; i < days?.length; i++) {
            let item = days[i];
            const holidays = holidayEvents?.filter(el => el?._date === item?.dateString);
            if (holidays?.length) {
                check = true;
                break;
            }
        }
        return check;
    }
    moveToClipboard = (event, callback) => {
        const COLS = this.generateCols()?.cols ?? [];
        const { LAYOUT } = this.generateLayout(COLS);
        let layoutItem = LAYOUT?.find(el => el.i === event._id);

        if (layoutItem) {
            const step = this.state.step ?? 5;
            let oldStartMinutes = layoutItem?.y * step;
            let oldStartTime = convertMinutesToTime(oldStartMinutes);
            let oldEndMinutes = (layoutItem?.y + layoutItem?.h) * step;
            let oldEndTime = convertMinutesToTime(oldEndMinutes);
            let oldData = {
                doctorId: COLS?.[layoutItem?.x]?._id,
                doctorName: COLS?.[layoutItem?.x]?.name
            };
            let date = COLS?.[layoutItem?.x]?.date;

            oldData.startTime = `${date} ${oldStartTime}`;
            oldData.endTime = `${date} ${oldEndTime}`;

            layoutItem.data = oldData;
        }

        if (event) {
            event.layoutItem = JSON.parse(JSON.stringify(layoutItem));
        }
        let clipboard = this.state.clipboard || [];
        if (!event?._id) return;

        if (!clipboard?.find(el => el._id === event._id)) {
            clipboard.push(event);

            this.setState({ clipboard }, () => {
                if (callback) callback();
                if (this.props.setClipboardData) {
                    this.props.setClipboardData(this.state.clipboard);
                }
            });
        }
    }
    removeFromClipboard = (eventId, callback) => {
        let clipboard = this.state.clipboard || [];
        if (clipboard?.find(el => el._id === eventId)) {
            clipboard = clipboard.filter(el => el._id !== eventId);
            this.setState({ clipboard }, () => {
                if (callback) callback();
                if (this.props.setClipboardData) {
                    this.props.setClipboardData(this.state.clipboard);
                }
            });
        }
    }
    onDrop = (layout, item, _event) => {
        const eventId = this.state.dragElementType?._id;
        const oldItem = layout?.find(el => el.i === this.state.dragElementType?._id) ?? this.state.dragElementType?.layoutItem;
        const newItem = {
            ...item,
            i: eventId
        }

        if (!oldItem || !newItem) return;

        this.onChangeEvent(layout, oldItem, newItem, () => {
            if (eventId) {
                this.setState({ dragElementType: null });
                this.removeFromClipboard(eventId);
            }
        });
    };


    render() {
        if (typeof window === 'undefined') {
            return;
        }
        const isMobileView = window.innerWidth < 768 ? true : false;
        const isTabletView = window.innerWidth < 1024 ? true : false;
        const isDesktopView = window.innerWidth >= 1024 ? true : false;


        const COLS = this.generateCols()?.cols ?? [];
        const headerDates = this.generateCols()?.headerDates ?? {};

        const { LAYOUT, ITEMS, DAY_SPLITTED } = this.generateLayout(COLS);

        // console.log('LAYOUT', LAYOUT, 'ITEMS', ITEMS)


        const STEP_HEIGHT = 10;
        const STEP = this.state.step * 60;
        const SECOND_HEIGHT = STEP_HEIGHT / STEP;
        const MAX_ROWS = 24 * 60 * 60 / STEP;

        const maxVisibleCols = this.getMaxVisibleCols();
        const VISIBLE_COLUMNS = isMobileView ? 5 : isTabletView ? 10 : maxVisibleCols;
        const containerWidth = this.calendarRef?.offsetWidth ? this.calendarRef?.offsetWidth - 50 : null;
        const columnWidth = COLS.length > VISIBLE_COLUMNS && containerWidth ?
            containerWidth / VISIBLE_COLUMNS
            :
            containerWidth / COLS.length;

        const WIDTH = columnWidth * COLS.length + 50;

        // console.log(STEP_HEIGHT, STEP, SECOND_HEIGHT, MAX_ROWS, columnWidth * COLS.length)

        const disabledZoomOut = this.state.zoom === 0 ? true : false;
        const numberOfDaysDict = {
            day: 1,
            week: 7,
            'work-week': 5
        };
        const disabledZoomIn = this.state.zoom === (numberOfDaysDict?.[this.state.view] - 1) ? true : false;

        const minStep = this.state.steps?.[0] ?? 1;
        const maxStep = this.state.steps?.[this.state.steps?.length - 1] ?? 30;
        const disabledStepZoomOut = this.state.step === minStep ? true : false;
        const disabledStepZoomIn = this.state.step === maxStep ? true : false;

        const customFilters = this.props.customFilters?.length ? this.props.customFilters : [];
        const legendData = this.props.legendData?.length ? this.props.legendData : [];

        const anyHolidayExists = this.checkIfAnyHolidayEventExists(headerDates?.days);


        const clipboard = this.state.clipboard || [];

        return (
            <div className='custom-calendar-component-wrap'>

                <div className='custom-calendar-navigation-wrap'>
                    <div className='custom-filters-navigation-wrap' >
                        {customFilters?.length ? customFilters : null}
                    </div>
                    <div className='custom-calendar-view-navigation' >
                        <Button
                            color='primary'
                            onClick={() => this.changeView('day')}
                        >
                            {'Day'.translate(this.props.lang)}
                        </Button>
                        <Button
                            color='primary'
                            onClick={() => this.changeView('work-week')}
                        >
                            {'Work week'.translate(this.props.lang)}
                        </Button>
                        <Button
                            color='primary'
                            onClick={() => this.changeView('week')}
                        >
                            {'Week'.translate(this.props.lang)}
                        </Button>
                    </div>
                    <div>
                        <DateNavigation
                            {...this.props}
                            date={this.state.date}
                            view={this.state.view}
                            headerDates={headerDates}
                            onChange={(date) => {
                                this.setState({ date })
                            }}
                        />
                    </div>
                </div>
                {
                    clipboard?.length ?
                        <div className='custom-calendar-clipboard-wrap'>
                            <h6>{'Clipboard'.translate(this.props.lang)}</h6>
                            <div className='custom-calendar-clipboard-content'>
                                {
                                    clipboard?.map((item, index) => {
                                        const start = this.props.getStringDateTs(item.startTime, 'HH:mm');
                                        const end = this.props.getStringDateTs(item.endTime, 'HH:mm');
                                        const time = `${start} - ${end}`;
                                        const title = generateTitle(item, this.props.lang);

                                        let props = {
                                            lang: this.props.lang,
                                            getStringDateTs: this.props.getStringDateTs,
                                            hideTitle: false,
                                            start,
                                            end,
                                            time,
                                            title,
                                            clipboardElement: true,
                                            selectedGroup: this.props.selectedGroup,
                                            selectedClinic: this.props.selectedClinic,
                                            removeFromClipboard: (eventId, callback) => {
                                                if (this.removeFromClipboard) {
                                                    this.removeFromClipboard(eventId, callback);
                                                }
                                            },
                                        }
                                        return (
                                            <div
                                                key={index}
                                                className='custom-calendar-clipboard-item'
                                                draggable={true}
                                                unselectable="on"
                                                onDragStart={e => {
                                                    this.setState({
                                                        dragElementType: item,
                                                    })
                                                    e.dataTransfer.setData("text/plain", "")

                                                }}
                                                onDragEnd={e => {
                                                    let setObj = {};
                                                    if (this.state.dragElementType) setObj.dragElementType = null;

                                                    if (Object.keys(setObj).length) {
                                                        this.setState(setObj);
                                                    }
                                                }}
                                            >
                                                {EVENT_TYPE(item, props)}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        :
                        null
                }
                <div className='custom-calendar-content-wrap' ref={(node) => this.calendarRef = node}>
                    <div className="custom-calendar-header-dates-wrap" style={{ width: WIDTH }}>
                        <div className="custom-calendar-header-dates-item-week-number" style={anyHolidayExists ? { height: 54 } : {}}>
                            {
                                headerDates?.weekNumber ?
                                    <>{'v.'.translate(this.props.lang)}{headerDates.weekNumber}</>
                                    :
                                    null
                            }
                        </div>
                        {
                            headerDates?.days?.map((item, idx) => {
                                const holidays = this.state.holidayEvents?.filter(el => el?._date === item?.dateString);
                                const selectable = this.state.view !== 'day' ? true : false;

                                let style = {
                                    width: columnWidth * (headerDates?.spanColumns || 0),
                                    cursor: selectable ? 'pointer' : 'default',
                                }
                                if (anyHolidayExists) {
                                    style.height = 54;
                                }
                                return (
                                    <div
                                        key={idx}
                                        className="custom-calendar-header-dates-item"
                                        style={style}
                                        onClick={() => {
                                            if (selectable) {
                                                this.setState({
                                                    date: item.dateString
                                                }, () => {
                                                    this.changeView('day')
                                                })
                                            }
                                        }}
                                    >
                                        <div className="custom-calendar-header-dates-item-date">
                                            {item.dateFormatted}
                                            {
                                                holidays?.length ?
                                                    holidays.map((el, index) => {
                                                        return (
                                                            <div className='custom-calendar-header-dates-item-date-holiday'>
                                                                <LightTooltipHoliday title={this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()} placement="top-start" >
                                                                    <div key={index} className="rbc-event-label " style={{ display: 'flex', maxWidth: 200, backgroundColor: '#e7e7e7', borderTopRightRadius: '5px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px', color: '#000', }}>
                                                                        <div style={{ backgroundColor: '#e61f00', height: 16, minWidth: 8 }}></div>
                                                                        <div style={{ paddingLeft: 5, paddingRight: 5, maxWidth: 200, fontSize: '12px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()}</div>
                                                                    </div>
                                                                </LightTooltipHoliday>
                                                            </div>
                                                        )

                                                    })
                                                    :
                                                    null

                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="custom-calendar-header" style={{ width: WIDTH }}>
                        {
                            COLS.map((item, idx) => {
                                let tooltipStyle = {};
                                let style = {
                                    width: idx === 0 ? columnWidth + 50 : columnWidth,
                                };
                                style.maxWidth = style.width;
                                if (idx === 0) {
                                    style.paddingLeft = 50;
                                    tooltipStyle.left = 50;
                                }
                                if (item.borderRight) {
                                    style.borderRight = '1px solid #bbb';
                                }

                                let headerItemStyle = {};
                                if (VISIBLE_COLUMNS > 21) {
                                    headerItemStyle.fontSize = 8;
                                } else if (VISIBLE_COLUMNS > 10) {
                                    headerItemStyle.fontSize = 9;
                                }

                                let tooltip;
                                let tooltipColumnName;
                                if (item?.daysWithDuplicates?.length && item?.date && item?.daysWithDuplicates?.indexOf(item?.date) > -1) {
                                    headerItemStyle.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                                    headerItemStyle.cursor = 'pointer';
                                    tooltip = 'There are events that overlap!'.translate(this.props.lang);
                                }
                                let maxWordLength = 12;
                                let addDot = false;
                                if (columnWidth < 30) {
                                    maxWordLength = 1;
                                    tooltipColumnName = item.name;
                                } else if (columnWidth < 65) {
                                    maxWordLength = 3;
                                    addDot = true;
                                    tooltipColumnName = item.name;
                                } else if (columnWidth < 100) {
                                    maxWordLength = 6;
                                    addDot = true;
                                    tooltipColumnName = item.name;
                                }
                                let tooltipClassName = 'custom-calendar-header-item-tooltip';
                                if (COLS?.length > 5 && idx > COLS?.length / 2) {
                                    tooltipClassName += ' custom-calendar-header-item-tooltip-right';
                                }

                                const name = formatName(item.name, maxWordLength, addDot);
                                return (
                                    <div key={idx} className="custom-calendar-header-column" style={style}>
                                        <div className="custom-calendar-header-item" style={headerItemStyle}>
                                            {name}
                                        </div>
                                        {
                                            tooltip || tooltipColumnName ?
                                                <div className={tooltipClassName} style={tooltipStyle}>
                                                    {tooltipColumnName}
                                                    {tooltipColumnName && tooltip ? <hr /> : null}
                                                    {tooltip}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className='custom-calendar-wrap' style={{ height: 24 * 60 * 60 * SECOND_HEIGHT, width: WIDTH }}>
                        <div className="custom-calendar-layout">
                            {
                                COLS.map((item, idx) => {
                                    let style = {
                                        width: idx === 0 ? columnWidth + 50 : columnWidth,
                                    };
                                    style.minWidth = style.width;

                                    const isToday = item?.isToday ? true : false;
                                    return (
                                        <div
                                            key={idx}
                                            className="custom-calendar-layout-column"
                                            style={style}
                                        >
                                            <div>
                                                {
                                                    DAY_SPLITTED?.map((block, bIdx) => {
                                                        let blockStyle = {
                                                            height: SECOND_HEIGHT * 60 * 60
                                                        };
                                                        if (item.borderRight) {
                                                            blockStyle.borderRight = '1px solid #bbb';
                                                        }
                                                        if (idx === 0) {
                                                            blockStyle.borderLeft = '1px solid #bbb';
                                                        }
                                                        if (isToday) {
                                                            blockStyle.backgroundColor = '#eaf6ff';
                                                        }
                                                        const scrollToBlock = block?.time === '07:00' ? true : false;
                                                        return (
                                                            <div
                                                                key={bIdx}
                                                                className="custom-calendar-layout-column-block"
                                                                style={blockStyle}
                                                                ref={(node) => {
                                                                    if (scrollToBlock && node) {
                                                                        this.calendarInitialBlockRef = node;
                                                                    }
                                                                }}
                                                            >
                                                                {!item.clipboard && idx === 0 ?
                                                                    <div className="custom-calendar-layout-column-block-time">
                                                                        {block.time}
                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                                <div className="custom-calendar-layout-column-block-grid">
                                                                    {
                                                                        ([...Array(Math.floor(60 * 60 / STEP))]).map((aItem, aIdx) => {
                                                                            return <div key={aIdx} className="custom-calendar-layout-column-block-grid-line"></div>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div style={{ height: 24 * 60 * 60 * SECOND_HEIGHT, width: WIDTH }}>
                            <RGL
                                layout={LAYOUT}
                                width={columnWidth * COLS.length}
                                margin={[0, 0]}
                                droppingItem={this.state.dragElementType && { i: 'test', w: 1, h: Math.ceil(((this.state.dragElementType?.endTime - this.state.dragElementType?.startTime) / STEP)) }}
                                // onDrop={this.onDrop}
                                onDrop={(layout, item, e) => {
                                    this.onDrop(layout, item, e)
                                }}
                                isDroppable={true}
                                cols={COLS.length}
                                rowHeight={STEP_HEIGHT}
                                // verticalCompact={false}
                                compactType={"horizontal"}
                                preventCollision={true}
                                maxRows={MAX_ROWS}
                                allowOverlap={true}
                                onDrag={(layout, oldItem, newItem, placeholder, e, element) => {
                                    let item = ITEMS?.find(el => el?._id == newItem?.i);
                                    this.updateLayoutElement(item, newItem)
                                }}
                                onDragStop={(layout, oldItem, newItem, placeholder, e, element) => {
                                    this.onChangeEvent(layout, oldItem, newItem);
                                    // console.log('multi-calendar-wrap', typeof window !== 'undefined' && document.getElementsByClassName('multi-calendar-wrap')?.[0]);

                                    // if (oldItem?.i?.indexOf('additional') > -1) {
                                    //     let index = layout.findIndex(el => el.i == oldItem.i);
                                    //     if (index > -1) {
                                    //         layout[index] = { ...oldItem }
                                    //     }
                                    // }
                                    // this.onLayoutChange(layout)
                                }}
                                onResize={(layout, oldItem, newItem, placeholder, e, element) => {
                                    let item = ITEMS?.find(el => el?._id == newItem?.i);
                                    this.updateLayoutElement(item, newItem)
                                }}
                                onResizeStop={(layout, oldItem, newItem, placeholder, e, element) => {
                                    this.onChangeEvent(layout, oldItem, newItem);
                                }}
                            >
                                {
                                    ITEMS.map((item, idx) => {
                                        const keyValue = item?._id;
                                        const className = `custom-calendar-drag-and-drop-calendar-event custom-calendar-drag-and-drop-calendar-event-${keyValue}`;
                                        const overlapData = item.overlapData ?? null;
                                        let style = {}
                                        const customClassName = `custom-calendar-drag-and-drop-calendar-event-${keyValue}`;
                                        if (overlapData?.position > -1 && overlapData?.total) {
                                            style.width = columnWidth / overlapData.total;
                                            style.left = columnWidth / overlapData.total * overlapData.position;
                                            if (overlapData?.position) {
                                                style.paddingLeft = 0;
                                            }
                                            this.setWidthOfElement(customClassName, style.width)
                                        }
                                        const isUpdated = this.props.updatedEvents?.includes(item?._id) ? true : false;
                                        if (item.type === 'event') {
                                            item.isMarkedAsDone = item?.isMarkedAsDone?.[item?.doctor] ?? false;
                                        }
                                        if (item?.doctor && COLS?.find(el => el?._id === item?.doctor)) {
                                            item.doctorName = COLS?.find(el => el?._id === item?.doctor)?.name;
                                            item.doctorProfessions = COLS?.find(el => el?._id === item?.doctor)?.professions ?? [];
                                        }

                                        return (
                                            <div
                                                key={keyValue}
                                                className={className}
                                                style={style}
                                                onMouseEnter={() => {
                                                    if (this.state.contextMenu?._id !== item?._id) {
                                                        this.setZIndexOfElement(customClassName, 999)
                                                    }
                                                }}
                                                onMouseLeave={() => {
                                                    if (this.state.contextMenu?._id !== item?._id) {
                                                        this.setZIndexOfElement(customClassName, null)
                                                    }
                                                }}
                                            >

                                                <CalendarEventComponent
                                                    {...this.props}
                                                    event={item}
                                                    style={style}
                                                    lang={this.props.lang}
                                                    getStringDateTs={this.props.getStringDateTs}
                                                    webBookingFormsDict={this.props.webBookingFormsDict}
                                                    updateEventIsDone={(isDone, id, doctor) => {
                                                        this.props.updateEventIsDone(isDone, id, doctor);
                                                    }}
                                                    columnWidth={columnWidth}
                                                    updatedLayoutElement={this.state.updatedLayoutElement}
                                                    isUpdated={isUpdated}
                                                    numberOfColumns={COLS?.length}
                                                    step={this.state.step}
                                                    view={this.state.view}
                                                    fetchItems={this.props.fetchItems}
                                                    handlingEvent={(event) => {
                                                        this.setState({ handlingEvent: event })
                                                    }}
                                                    clipboard={this.state.clipboard || []}
                                                    moveToClipboard={(event, callback) => {
                                                        this.moveToClipboard(event, callback);
                                                    }}
                                                    removeFromClipboard={(eventId, callback) => {
                                                        this.removeFromClipboard(eventId, callback);
                                                    }}
                                                    setContextMenu={(contextMenu) => {
                                                        this.setState({ contextMenu }, () => {
                                                            if (contextMenu?._id === item?._id) {
                                                                this.setZIndexOfElement(customClassName, 9999)
                                                            } else {
                                                                this.setZIndexOfElement(customClassName, null)
                                                            }
                                                        });
                                                    }}
                                                    _contextMenu={this.state.contextMenu}
                                                />
                                            </div>
                                        )

                                    })
                                }

                            </RGL>
                        </div>

                    </div>

                </div>
                <div className='custom-calendar-footer-wrap'>
                    <CalendarLegend
                        lang={this.props.lang}
                        hasSemble={this.props.hasSemble}
                        hasTakeCare={this.props.hasTakeCare}
                    />
                    {/* <div className='custom-calendar-footer-legend-wrap'>
                        {
                            legendData?.map((item, idx) => {
                                return (
                                    <div key={idx} className='custom-calendar-footer-legend-item-wrap'>
                                        <div className='custom-calendar-footer-legend-item-color' style={{ backgroundColor: item.color }}></div>
                                        <div className='custom-calendar-footer-legend-item-text'>{item.name}</div>
                                    </div>
                                )
                            })
                        }
                    </div> */}
                    <div className='custom-calendar-footer-zoom-options-wrap'>
                        <div className='custom-calendar-footer-zoom-wrap'>
                            <h6>{'Zoom'.translate(this.props.lang)}:</h6>
                            <Button
                                color='primary'
                                onClick={() => this.stepZoomIn()}
                                disabled={disabledStepZoomIn}
                            >
                                -
                            </Button>
                            <Button
                                color='primary'
                                onClick={() => this.stepZoomOut()}
                                disabled={disabledStepZoomOut}
                            >
                                +
                            </Button>
                        </div>
                        <div className='custom-calendar-footer-zoom-wrap'>
                            <h6>{'Horizontal zoom'.translate(this.props.lang)}:</h6>
                            <Button
                                color='primary'
                                onClick={() => this.zoomOut()}
                                disabled={disabledZoomOut}
                            >
                                -
                            </Button>
                            <Button
                                color='primary'
                                onClick={() => this.zoomIn()}
                                disabled={disabledZoomIn}
                            >
                                +
                            </Button>
                        </div>
                    </div>
                </div>
            </div>


        )
    }
}

export default CustomCalendar;